var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNestling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 270",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2986",
    transform: "matrix(0.5352639555931091, 0, 0, 0.5301560163497925, -16.184349060058594, -0.17847302556038613)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10893",
    transform: "translate(8586.6862,-15157.851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -8328.6562,15611.875 c -16.8879,0.226 -34.2205,3.522 -51.1876,10.219 -67.985,26.835 -103.6146,98.035 -79.5624,158.968 0.495,1.256 5.3339,14.664 12.4687,26.719 20.5031,-29.097 41.0024,-58.19 61.4687,-87.312 l 1.875,-2.688 c 22.086,41.042 44.2653,82.034 66.375,123.063 17.1743,-14 34.3698,-27.961 51.5626,-41.938 17.1911,-13.979 34.3831,-27.969 51.5312,-42 12.2955,12.674 24.5889,25.349 36.875,38.032 -3.3483,-38.763 -25.6961,-97.405 -38.5,-121.532 l 33.25,-29.031 -44.5,7.625 19.9688,-37.719 -40.125,24.469 c -22.6183,-19.569 -49.2595,-27.309 -81.5,-26.875 z m 38.3437,47.563 c 5.9861,-0.104 11.9441,1.864 16.1563,5.187 22.5969,22.849 -13.4424,49.939 -30.5313,37.719 -5.039,-4.077 -8.1624,-9.833 -8.8437,-16.282 -0.6777,-6.444 1.2108,-12.8 5.2812,-17.843 2.6319,-3.254 6.0325,-5.783 9.9062,-7.313 2.5662,-0.989 5.3103,-1.423 8.0313,-1.468 z",
    id: "path3-737",
    style: {
      fill: "#333333",
      fillOpacity: 1
    },
    transform: "translate(0,-448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -8385.1297,15296.309 -90.4862,128.288 -60.8299,-62.83 c -6.5609,30.979 -10.1075,60.346 -10.1075,85.636 0,132.112 96.618,216.442 215.8487,216.442 119.2021,0 215.8855,-84.33 215.8855,-216.442 0,-5.26 -0.1796,-10.697 -0.4814,-16.291 l -99.9271,-103.184 -106.1471,86.338 -63.755,-117.957 z",
    id: "path10720",
    style: {
      fill: "#333333",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -8329.9748,15672.369 a 9.25667,9.25667 0 1 1 -18.5133,0 9.25667,9.25667 0 1 1 18.5133,0 z",
    id: "path10824",
    style: {
      fill: "#333333",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.99997194,0,0,0.99997194,46.208459,-445.16627)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestling);
export default __webpack_public_path__ + "static/media/nestling.b70b252a55d377ffe65ac330fb644a80.svg";
export { ForwardRef as ReactComponent };